<template>
  <div :class="device.isMobile ? 'py-2' : 'px-4 pb-2'">
    <v-data-table
      :headers="getMobileHeaders(headers)"
      :items="customSearch(translatedRestaurantMeals, headers, filters.search)"
      :items-per-page="-1"
      class="ordera-box-shadow striped-table"
      hide-default-footer
      disable-pagination
      mobile-breakpoint="0"
    >
    </v-data-table>
  </div>
</template>

<script>
import reportService from "@/services/report";
import hasPrinting from "@/mixins/hasPrinting";
import hasReportPrinting from "@/mixins/report/hasReportPrinting";
import hasExcel from "@/mixins/hasExcel";
import hasReloadWatch from "@/mixins/report/hasReloadWatch";
import hasMobileHeaders from "@/mixins/report/hasMobileHeaders";

export default {
  mixins: [hasPrinting, hasReportPrinting, hasExcel, hasReloadWatch, hasMobileHeaders],
  data() {
    return {
      restaurantMeals: [],
      loading: false,
    };
  },
  methods: {
    fetchRestaurantMeals() {
      this.loading = true;
      reportService
        .getRestaurantChildRestaurant(this.$store.state.restaurant.id, {
          date: this.filters.dates.from,
          date2: this.filters.dates.to,
          food: true,
        })
        .then((response) => {
          this.restaurantMeals = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    translatedRestaurantMeals() {
      return this.restaurantMeals.map((restaurant, index) => {
        return {
          num: index + 1,
          count: restaurant.count,
          name: this.translate(restaurant.name),
        };
      });
    },
    headers() {
      return [
        { text: this.$t("r_b"), value: "num" },
        { text: this.$t("restaurant"), value: "name" },
        { text: this.$t("meal_num"), value: "count" },
      ];
    },
    filters() {
      return this.$store.state.report.filters;
    },
  },
  watch: {
    "filters.dates": {
      handler() {
        this.fetchRestaurantMeals();
      },
      immediate: true,
      deep: true,
    },
    isPrinting() {
      if (this.isPrinting) {
        this.printDocument({
          tables: [
            {
              headers: this.headers,
              items: this.translatedRestaurantMeals,
              showCaption: true,
            },
          ],
          title: [this.$t("report"), this.$t("restaurants")].join(": "),
          subtitle: this.subtitle,
          hideDatetime: true,
        });
      }
    },
    isExcelDownloading() {
      if (this.isExcelDownloading) {
        this.downloadExcel({
          fileName: [this.$t("report"), this.$t("restaurants")].join(" ") + ".xlsx",
          sheets: [
            {
              name: this.$t("restaurants"),
              headers: this.headers,
              items: this.translatedRestaurantMeals,
              title: [this.$t("report"), this.$t("restaurants")].join(" "),
              subtitle: this.subtitle,
            },
          ],
        });
      }
    },
  },
};
</script>
